<template>
  <VehicleCatalog :blok="ported" />
  <!-- </div> -->
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-catalog",
  computed: {
    ported() {
      const port = this.blok;
      port.title = ""
      port.locale_append_text = "Load More"
      port.locale_cta_text = ""
      return port
    }
  }
}
</script>

<style scoped>
.fix>*>* {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
